var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPylon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.284,479.938l-47.938-346.766h52.622v17.016h-16.426v31.34h16.426v17.117h-16.426v31.34h16.426v19.327h31.34v-19.327 h16.427v-31.34h-16.427V181.53h16.427v-31.34h-16.427v-48.357h-88.295l-2.507-18.137h22.577V0H154.018v83.696h22.577 l-2.507,18.137H85.692v48.356H69.265v31.34h16.427v17.117H69.265v31.34h16.427v19.327h31.34v-19.327h16.426v-31.34h-16.426V181.53 h16.426v-31.34h-16.426v-17.017h52.724l-47.938,346.766H44.98v31.34h94.226l0.697,0.722l0.748-0.722h229.318l0.748,0.722 l0.698-0.722h95.606v-31.34H390.284z M185.357,31.34h141.387v21.016H185.357V31.34z M205.474,103.644l2.758-19.949h95.637 l2.64,19.098l-51.139,35.004L205.474,103.644z M227.629,156.788l-32.585,22.304l5.634-40.752L227.629,156.788z M311.306,137.489 l5.894,42.632l-34.088-23.333L311.306,137.489z M189.246,221.04l66.126-45.263l67.627,46.292l6.068,43.892H183.035L189.246,221.04 z M317.177,297.3l-61.867,59.725L193.444,297.3H317.177z M175.125,323.177l57.624,55.63l-75.374,72.764L175.125,323.177z  M173.114,479.938l82.197-79.352l82.196,79.352H173.114z M277.872,378.805l58.93-56.89l18.152,131.305L277.872,378.805z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPylon);
export default __webpack_public_path__ + "static/media/pylon.6b8afc9deaf5034532ce4d5452637532.svg";
export { ForwardRef as ReactComponent };